// File: src/firebaseConfig.js
// Copyright (c) 2025 DefoAI UG (haftungsbeschränkt)
// All rights reserved.
//
// Central Firebase configuration and initialization.

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";

// Parse Firebase config from environment variable (JSON string)
const jsonFile = process.env.REACT_APP_FIREBASE_CONFIG;
if (!jsonFile) {
  throw new Error('REACT_APP_FIREBASE_CONFIG environment variable is not set');
}

const firebaseConfig = JSON.parse(jsonFile);

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Set auth persistence to local storage to prevent automatic sign-outs
setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.error('Failed to set auth persistence:', error);
});

export const googleProvider = new GoogleAuthProvider();



